import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';

export const paginationPageSizeDropDownSelections = [
  { key: '5', label: '5', isActive: false },
  { key: '10', label: '10', isActive: false },
  { key: '20', label: '20', isActive: false },
  { key: '50', label: '50', isActive: false },
  {
    key: '100',
    label: '100',
    isActive: false
  },
  { key: '500', label: '500', isActive: false },
  { key: '1000', label: '1000', isActive: false }
] as DropDownItemType[];
